//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    onShareAppMessage () {
        const sub_page = encodeURIComponent('/pages/packageA/contact_us/join/main')
        return this.getShareInfo({
            title: `加入我们`,
            path: `/pages/index/main?sub_page=${sub_page}`
        })
    }
}
